import React from 'react'
import { Button } from '@mui/material'

export default function PinkLightButton({startIcon,buttonTitle,onClick}) {
  return (
    <Button
            variant="contained"
            startIcon={startIcon?startIcon:""}
             onClick={onClick}
            sx={{
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 600,
              textTransform: "none",
              backgroundColor: "#F9ECF7",
              color:"#9D0385",
              px:3,
              "&:hover": {
                backgroundColor: "#F9ECF7",
              },
            }}
          >
            {buttonTitle}
          </Button>
  )
}
